import React, { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from 'shared/store';
import {
  selectHaveRealtimeVisitorsLoaded,
  selectIncomingCameraVideoStream,
  selectRealtimeVisitor,
  sendResetRrweb,
} from 'shared/store/realtime-slice';
import './style.less';

import BgImg from 'shared/assets/images/chat-call-bg.png';
import { SessionChatMiniRrweb } from 'browser/components/Dashboard/SessionChat/SessionChatMiniRrweb';
import Loader from 'shared/components/Loader';

export const ChatPopupIncomingVideo: React.FC<{ visitorId: string }> = ({
  visitorId,
}) => {
  const dispatch = useAppDispatch();

  const associationStatus = useAppSelector(s => s.realtime.associationStatus);
  const activeVisitor = useAppSelector(state => selectRealtimeVisitor(state, visitorId));
  const haveVisitorsLoaded = useAppSelector(selectHaveRealtimeVisitorsLoaded);

  const { isAwaitingReplayerFirstRender } = useAppSelector(state => state.dashboard);

  const isVisitorOnline = !!activeVisitor?.sid;
  const isVisitorOnlineUnknown = !haveVisitorsLoaded;
  const isHelpedByOther = associationStatus === 'busy';

  const isConnecting =
    !isHelpedByOther &&
    (isVisitorOnline || isVisitorOnlineUnknown) &&
    isAwaitingReplayerFirstRender;

  const videoRef = useRef<HTMLVideoElement | null>(null);

  const camVideoStreamIn = useAppSelector(selectIncomingCameraVideoStream);

  useEffect(() => {
    if (!videoRef.current) return;
    if (!camVideoStreamIn) return;

    videoRef.current.muted = true;
    videoRef.current.srcObject = camVideoStreamIn;

    videoRef.current.play().catch(_error => {
      // no op for now
    });
  }, [camVideoStreamIn]);

  useEffect(() => {
    if (camVideoStreamIn) return;

    dispatch(sendResetRrweb());
  }, [camVideoStreamIn, dispatch]);

  return (
    <div className="ChatPopupIncomingVideo">
      <img className="ChatPopupIncomingVideo__bg" src={BgImg} alt="background" />
      <SessionChatMiniRrweb isChatCollapsed />
      {isConnecting && (
        <div className="ChatPopupIncomingVideo__mask">
          <img className="ChatPopupIncomingVideo__bg" src={BgImg} alt="background" />
          <Loader inline size="small" />
        </div>
      )}
      {camVideoStreamIn && (
        <video className="ChatPopupIncomingVideo__video" ref={videoRef} />
      )}
    </div>
  );
};
